import * as C from '../constants';
import CoreService from '../../../services/core-service';
import AffiliateService from '../../../services/affiliates-service';

export default {

  /**
   * @param commit
   */
  resetState({ commit }) {
    commit(C.AFFILIATES_RESET);
  },

  /**
   * @param commit
   */
  getDomains({ commit }) {
    commit(C.AFFILIATES_DOMAINS_PENDING);
    CoreService.getDomains().then((res) => {
      commit(C.AFFILIATES_DOMAINS_SUCCESS, res.data);
    }).catch(() => {
      commit(C.AFFILIATES_DOMAINS_FAILURE);
    });
  },

  /**
   * @param commit
   * @param dispatch
   */
  getAffiliates({ commit, dispatch }) {
    commit(C.AFFILIATES_PENDING);
    AffiliateService.getAffiliates().then((res) => {
      if (res.status === 204) {
        commit(C.AFFILIATES_NO_CONTENT);
      } else {
        commit(C.AFFILIATES_SUCCESS, res.data);
      }
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_FAILURE);
    });
    dispatch('getDomains');
  },

  /**
   * @param commit
   * @param affiliateId
   */
  getAffiliate({ commit }, affiliateId) {
    commit(C.AFFILIATES_AFFILIATE_PENDING);
    AffiliateService.getAffiliate(affiliateId).then((res) => {
      const suppliers = {};
      res.data.domains.forEach((domain) => {
        domain.affiliateDomainSuppliers.forEach((supplier) => {
          if (!suppliers[supplier.supplierId]) {
            suppliers[supplier.supplierId] = supplier;
            suppliers[supplier.supplierId].domains = [];
          }
          suppliers[supplier.supplierId].domains.push(domain.id);
        });
      });
      commit(C.AFFILIATES_AFFILIATE_SUCCESS, res.data);
      commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_SET, Object.values(suppliers));
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_FAILURE);
    });
  },

  /**
   * @param commit
   * @param payload
   */
  createAffiliate({ commit }, payload) {
    commit(C.AFFILIATES_AFFILIATE_PENDING);
    AffiliateService.createAffiliate(payload).then((res) => {
      commit(C.AFFILIATES_AFFILIATE_SUCCESS, res.data);
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_FAILURE);
    });
  },

  /**
   * @param commit
   * @param state
   * @param payload
   * @returns AxiosPromise
   */
  updateAffiliate({ commit, state }, payload) {
    commit(C.AFFILIATES_AFFILIATE_UPDATE_PENDING);
    return AffiliateService.updateAffiliate(payload.id, payload.params).then(() => {
      const index = state.affiliates.items.findIndex(a => a.id === payload.id);
      commit(C.AFFILIATES_AFFILIATE_UPDATE_SUCCESS, {
        newAffiliate: payload.params,
        affiliateIndex: index,
      });
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_UPDATE_FAILURE);
    });
  },

  /**
   * @param commit
   * @param dispatch
   * @param state
   * @param payload
   * @returns AxiosPromise
   */
  syncDomains({ commit, dispatch, state }, payload) {
    commit(C.AFFILIATES_AFFILIATE_UPDATE_PENDING);
    return AffiliateService.syncDomains(state.affiliate.item.id, payload).then(() => {
      dispatch('getAffiliate', state.affiliate.item.id);
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_UPDATE_FAILURE);
    });
  },

  /**
   * @param commit
   * @param state
   * @param payload
   * @returns AxiosPromise
   */
  updateLogo({ commit, state }, payload) {
    commit(C.AFFILIATES_AFFILIATE_LOGO_PENDING);
    return AffiliateService.updateLogo(
      payload.affiliateId,
      payload.affiliateDomainId,
      payload.formData,
    ).then((res) => {
      const index = state.affiliate.item.domains.findIndex(d => d.id === payload.affiliateDomainId);
      commit(C.AFFILIATES_AFFILIATE_LOGO_SUCCESS, {
        affiliateDomainIndex: index,
        logo: res.data.logo,
      });
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_LOGO_FAILURE);
    });
  },

  /**
   * @param commit
   */
  getSuppliers({ commit }) {
    commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_PENDING);
    AffiliateService.getSuppliers().then((res) => {
      commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_SUCCESS, res.data);
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_FAILURE);
    });
  },

  /**
   * @param commit
   * @param payload
   */
  addSupplier({ commit }, payload) {
    commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_ADD, payload);
  },

  /**
   * @param commit
   * @param state
   * @param payload
   */
  syncSupplier({ commit, state }, payload) {
    commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_PENDING);
    AffiliateService.syncSupplier(state.affiliate.item.id, payload).then(() => {
      const index = state.affiliateSuppliers.items.findIndex(
        s => s.supplierId === payload.supplierId,
      );
      if (payload.affiliateDomainIds.length) {
        commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_SUCCESS, {
          affiliateSupplierIndex: index,
          domains: payload.affiliateDomainIds,
        });
      } else {
        commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_REMOVE, index);
        commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_SUCCESS);
      }
    }).catch(() => {
      commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_FAILURE);
    });
  },

  /**
   * @param commit
   * @param payload
   * @param supplierId
   */
  deleteSupplier({ commit, state }, supplierId) {
    const index = state.affiliateSuppliers.items.findIndex(
      s => s.supplierId === supplierId,
    );
    commit(C.AFFILIATES_AFFILIATE_SUPPLIERS_REMOVE, index);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/affiliate/actions.js